import React, { Fragment, Component } from 'react';
import {
    RepeatTimeContainer,
    RepeatInfoContainer,
    CircleOutline,
    CircleBody,
    ExerciseImage,
    RightSideContainer,
} from './style';
import { Text } from '../../../../UI/Text';
import { Countdown } from '../../../../Components/Countdown';
import { OuterIndent, Row } from '../../../../Layouts';
import { roundNumber, lbsToKgs } from '../../../../../Utils';

export class RepeatWorkoutContent extends Component {
    state = {
        exercises: [],
        currentExercise: {},
        exerciseOrder: 0,
    };

    componentDidMount() {
        const { breakDown } = this.props;
        const exercises = avoidRounds(breakDown);
        this.setState({ exercises });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.start !== this.props.start && this.props.start === true) this.startExercising();
    }

    startExercising = () => {
        const { exercises } = this.state;
        if (exercises.length !== 0) {
            this.setState({ currentExercise: exercises[0] });
            this.changeExercise(exercises[0].time);
        } else {
            this.props.finish();
        }
    };

    changeExercise = time => {
        const { exercises, exerciseOrder } = this.state;

        this.timer = setTimeout(() => {
            exercises.shift();
            this.setState({
                exercises,
                currentExercise: exercises[0],
                exerciseOrder: exerciseOrder + 1,
            });
            this.startExercising();
        }, time * 1000);
    };

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    render() {
        const { currentExercise, exerciseOrder, exercises } = this.state;
        return (
            exercises.length && (
                <Fragment>
                    <RepeatInfoContainer>
                        <ExerciseDataContainer exercise={currentExercise} />
                    </RepeatInfoContainer>
                    <RepeatTimeContainer>
                        {currentExercise.time && <TimeContainer key={exerciseOrder} timeValue={currentExercise.time} />}
                    </RepeatTimeContainer>
                </Fragment>
            )
        );
    }
}

const TimeContainer = ({ timeValue, key }) => {
    return (
        <CircleOutline>
            <CircleBody>
                <Countdown key={key} countdownStart={timeValue} />
            </CircleBody>
        </CircleOutline>
    );
};

const ExerciseDataContainer = ({ exercise }) => (
    <RightSideContainer>
        <OuterIndent indent={'0 0 30px 0'}>
            <ExerciseImage background={exercise.orangeImage} />
        </OuterIndent>
        <Text alignCenter={true} size={'3vw'} weight={'bold'}>
            {exercise.exerciseName}
        </Text>
        <OuterIndent indent={'12px 0 0 0 '}>
            <Row>
                {exercise.isDistanceRequired ? (
                    <Text size={'2vw'} opacity={0.7} weight={'bold'}>
                        {roundNumber(exercise.distance, 1)} Km
                    </Text>
                ) : (
                    <Fragment>
                        {exercise.exerciseId !== 276 && (
                            <Fragment>
                                <OuterIndent indent={'0 20px 0 0'}>
                                    <Text size={'2vw'} opacity={0.7} weight={'bold'}>
                                        {exercise.repsCount} Reps
                                    </Text>
                                </OuterIndent>
                                <Text size={'2vw'} opacity={0.7} weight={'bold'}>
                                    {exercise.kgCount >= 0 ? lbsToKgs(exercise.kgCount) : 'N/A'} Kgs
                                </Text>
                            </Fragment>
                        )}
                    </Fragment>
                )}
            </Row>
        </OuterIndent>
    </RightSideContainer>
);

const avoidRounds = exercises => {
    return exercises.map(exercise => {
        if (!exercise.isRound) return exercise;
    });
};



// WEBPACK FOOTER //
// ./src/UI/Containers/GymTv/Repeat/Content/RepeatWorkoutContent.js